module.exports = __webpack_public_path__ + "static/media/carasole1.f008e33a.jfif";